import ChartAxisLabel from './ChartAxisLabel'

export default ChartAxisLabel
